import apiClient from './apiService';

class AffiliateRollCallService {
    constructor() {
        if (AffiliateRollCallService.instance) {
            return AffiliateRollCallService.instance;
        }
        AffiliateRollCallService.instance = this;
    }

    async getAffiliates(page, pageSize, filters = {}) {
        try {
            const params = { page, pageSize, ...filters };
            const response = await apiClient.get('/affiliate-roll-calls/affiliates', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching affiliates:', error);
            throw error.response?.data || error;
        }
    }

    async create(data) {
        try {
            const response = await apiClient.post('/affiliate-roll-calls', data);
            return response.data;
        } catch (error) {
            console.error('Error creating affiliate roll-call:', error);
            throw error.response?.data || error;
        }
    }

    static getInstance() {
        if (!AffiliateRollCallService.instance) {
            AffiliateRollCallService.instance = new AffiliateRollCallService();
        }
        return AffiliateRollCallService.instance;
    }
}

export default AffiliateRollCallService.getInstance();
